import * as React from "react";
import { styled } from "@mui/material/styles";
import Chip from "@mui/material/Chip";
import Paper from "@mui/material/Paper";
import TagFacesIcon from "@mui/icons-material/TagFaces";
import { Button } from "@mui/material";

const ListItem = styled("li")(({ theme }) => ({
  margin: theme.spacing(0.5),
}));

const SearchChip = (props) => {
  const {
    checkboxHandler,
    topicData,
    courseLanguages,
    courseLevels,
    progressionData,
    coursePrice,
  } = props;

  const chipStyle = {
    p: 0,
    height: "24px !important",
    background: "#E4E8EC !important",
    borderRadius: "12px !important",
    fontSize: "12px !important",
  };

  // console.log(searchChips);

  const handleDelete = (index, data, type) => () => {
    data["checked"] = false;
    checkboxHandler(index, data, type);
  };

  // const handleClearAll = () => {
  //   setSearchChips([]);
  // };

  return (
    <>
      <Paper
        sx={{
          boxShadow: "none !important",
          display: "flex",
          justifyContent: "flex-start",
          flexWrap: "wrap",
          listStyle: "none",
          p: 0.5,
          m: 0,
        }}
        component="ul"
      >
        {topicData.map((data, index) => {
          return (
            <>
              {data.checked && (
                <ListItem key={data.id}>
                  <Chip
                    label={data.label}
                    sx={chipStyle}
                    onDelete={handleDelete(index, data, "topicData")}
                  />
                </ListItem>
              )}
            </>
          );
        })}

        {/* lavels */}
        {courseLevels?.map((data, index) => {
          return (
            <>
              {data.checked && (
                <ListItem key={data.id}>
                  <Chip
                    label={data.label}
                    sx={chipStyle}
                    onDelete={handleDelete(index, data, "courseLevels")}
                  />
                </ListItem>
              )}
            </>
          );
        })}

        {/* laveprogressionDatals */}
        {progressionData?.map((data, index) => {
          return (
            <>
              {data.checked && (
                <ListItem key={data.id}>
                  <Chip
                    label={data.label}
                    sx={chipStyle}
                    onDelete={handleDelete(index, data, "progressionData")}
                  />
                </ListItem>
              )}
            </>
          );
        })}

        {/* languages */}
        {courseLanguages?.map((data, index) => {
          return (
            <>
              {data.checked && (
                <ListItem key={data.id}>
                  <Chip
                    label={data.label}
                    sx={chipStyle}
                    onDelete={handleDelete(index, data, "courseLanguages")}
                  />
                </ListItem>
              )}
            </>
          );
        })}

        {/* coursePrice */}
        {coursePrice?.map((data, index) => {
          return (
            <>
              {data.checked && (
                <ListItem key={data.id}>
                  <Chip
                    label={data.label}
                    sx={chipStyle}
                    onDelete={handleDelete(index, data, "coursePrice")}
                  />
                </ListItem>
              )}
            </>
          );
        })}

        {/* {searchChips.length > 0 && (
          <Button
            variant="text"
            // onClick={handleClearAll}
            sx={{
              textTransform: "capitalize",
              textDecoration: "underline",
              "&:hover": { textDecoration: "underline" },
            }}
          >
            Clear All
          </Button>
        )} */}
      </Paper>
    </>
  );
};

export default SearchChip;
